import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { RepayAchPageRoutingModule } from './repay-ach-routing.module';

import { RepayAchPage } from './repay-ach.page';
import { MasterHeaderModule } from '../../../../master-header/master-header.module';
import { MasterFooterModule } from '../../../../master-footer/master-footer.module';
import { CustomInputModule } from '../../../../common-components/custom-input/custom-input.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    RepayAchPageRoutingModule,
    MasterHeaderModule,
    MasterFooterModule,
    CustomInputModule,
  ],
  declarations: [RepayAchPage],
})
export class RepayAchPageModule {} 